if (!customElements.get('wonderly-quick-add')) {
  customElements.define(
    'wonderly-quick-add',
    class WonderlyQuickAdd extends HTMLElement {
      constructor() {
        super();
        this.onSubmitClick = this.onSubmitClick.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onOutsidePointer = this.onOutsidePointer.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
      }

      connectedCallback() {
        this.submitButton = this.querySelector('.wonderly-pc__atc');
        this.quantityInput = this.querySelector('input[name="quantity"]');
        this.form = this.closest('form');
        if (!this.submitButton || !this.quantityInput || !this.form) return;

        // "Added ✓" on the control once the cart accepted the add. It stays
        // until a DIFFERENT product is added (or this one leaves the cart).
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (!event) return;
            const idInput = this.form.querySelector('[name="id"]');
            const variantId = idInput ? String(idInput.value) : null;
            if (event.source === 'product-form') {
              if (variantId && String(event.productVariantId) === variantId) this.markAdded();
              else this.clearAdded();
              return;
            }
            // Full-cart payloads (quantity change / remove in the drawer or page):
            // drop the state once this variant is no longer in the cart.
            const cart = event.cartData;
            if (cart && Array.isArray(cart.items) && 'item_count' in cart && variantId) {
              const stillThere = cart.items.some((item) => String(item.variant_id) === variantId);
              if (!stillThere) this.clearAdded();
            }
          });
        }

        // Touch devices: CSS keeps the pill permanently open (no tap-to-expand
        // step), so the stepper is a plain always-visible control there.
        if (this.alwaysOpen) this.submitButton.setAttribute('aria-expanded', 'true');

        this.submitButton.addEventListener('click', this.onSubmitClick);
        this.form.addEventListener('submit', this.onFormSubmit);
      }

      get alwaysOpen() {
        return window.matchMedia('(hover: none)').matches;
      }

      disconnectedCallback() {
        document.removeEventListener('pointerdown', this.onOutsidePointer);
        document.removeEventListener('keyup', this.onKeyUp);
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      // Collapsed circle shows ✓ instead of +; the expanded pill reads "Added ✓".
      // A tap-expanded pill collapses so the ✓ is what's left on screen.
      markAdded() {
        this.classList.add('is-added');
        if (this.classList.contains('is-open')) this.close();
      }

      clearAdded() {
        this.classList.remove('is-added');
      }

      onSubmitClick(event) {
        const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        // Fallback tap-to-expand only for devices that neither hover-expand
        // nor match the (hover: none) always-open CSS.
        if (!hoverCapable && !this.alwaysOpen && !this.classList.contains('is-open')) {
          event.preventDefault();
          this.open();
        }
      }

      open() {
        this.classList.add('is-open');
        this.submitButton.setAttribute('aria-expanded', 'true');
        // Defer so the opening tap's pointerdown doesn't immediately close it.
        setTimeout(() => {
          document.addEventListener('pointerdown', this.onOutsidePointer);
          document.addEventListener('keyup', this.onKeyUp);
        });
      }

      close() {
        this.classList.remove('is-open');
        this.submitButton.setAttribute('aria-expanded', 'false');
        document.removeEventListener('pointerdown', this.onOutsidePointer);
        document.removeEventListener('keyup', this.onKeyUp);
      }

      onOutsidePointer(event) {
        if (!this.contains(event.target)) this.close();
      }

      onKeyUp(event) {
        if (event.code === 'Escape') this.close();
      }

      onFormSubmit() {
        // product-form.js reads FormData synchronously during submit dispatch,
        // so a macrotask reset never races the cart request payload. The ✓
        // itself waits for the cart's success (see flashAdded).
        setTimeout(() => {
          this.quantityInput.value = this.quantityInput.min || 1;
          this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    }
  );
}
